document.addEventListener('DOMContentLoaded', function () {
    // 1. Sign up button logic (Modified for multiple classes)
    document.addEventListener('click', function (e) {
        // ADD YOUR CLASSES HERE: Just separate them with commas
        //const signupClasses = '.sign-up-button, .mm-promo-banner, .ai-clickable-hero-az2yxcw9uvmrpdkovmaigenblock55dd4e5znmqjc';
        const signupClasses = '.sign-up-button, .mm-promo-banner';
        
        const button = e.target.closest(signupClasses);
        if (!button) return;

        e.preventDefault();

        if (window.innerWidth >= 760) {
            // desktop creative
            window.__attentive?.trigger(null, null, null, 1011952);
        } else {
            // mobile creative
            window.__attentive?.trigger(null, null, null, 1011958);
        }
    });

    // 2. Collection "Read More" logic (Remains the same)
    const collectionHeroReadMore = document.querySelector('.collection-hero-read-more');
    const collectionLongDescription = document.querySelector('.collection_long_description');
    
    if (collectionHeroReadMore && collectionLongDescription) {
        collectionHeroReadMore.addEventListener('click', function(e) {
          e.preventDefault();
          window.scrollTo(0, 5);
          
          setTimeout(function() {
            const headerElement = document.querySelector('#header');
            if (headerElement) {
                const headerHeight = headerElement.offsetHeight;
                const targetPosition = collectionLongDescription.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                  top: targetPosition - headerHeight,
                  behavior: 'smooth'
                });
            }
          }, 50);
        });
    }

    // 3. Collection "Show More" logic (Remains the same)
    const collectionHeroShowMore = document.querySelector('.collection-hero-show-more');
    const collectionHeroContent = document.querySelector('.collection-hero__entry > div');
            
    if (collectionHeroShowMore && collectionHeroContent) {
        collectionHeroShowMore.addEventListener('click', function(e) {
            e.preventDefault();

            if (!collectionHeroContent.classList.contains('shown')) {
                collectionHeroContent.style.maxHeight = collectionHeroContent.scrollHeight + 'px';
                collectionHeroContent.classList.add('shown');
                
                collectionHeroShowMore.style.opacity = '0';
                collectionHeroShowMore.style.transform = 'translateY(2rem)';
            }
        });
    }
});